import React from "react";
import { Stack, Typography } from "@mui/material";
import { CustomModal } from "@/components/Modal";
import { Button, ButtonVariantOption } from "@/components/Button";
import { PageTitle } from "@/components/Title";
import { SizingWrapperStyle } from "@/components/Wrapper";

interface OrderConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isSubmitting: boolean;
}

/**
 * 注文確認ダイアログ
 * 注文確定前の最終確認を行うモーダルダイアログ
 */
export const OrderConfirmDialog: React.FC<OrderConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  isSubmitting,
}) => {
  const handleModalClose = (
    _event: Record<string, unknown>,
    _reason: "backdropClick" | "escapeKeyDown"
  ): void => {
    if (isSubmitting) return;
    onClose();
  };

  return (
    <CustomModal
      isOpen={open}
      handleClose={handleModalClose}
      ariaLabelledby="order-confirm-dialog"
      ariaDescribedby="order-confirm-dialog-description"
      width={"500px"}
    >
      <Stack direction={"column"} spacing={2}>
        <PageTitle>注文確認</PageTitle>
        <Typography variant="body1">
          注文を確定しますか？確定後のキャンセルはできません。
        </Typography>
        <Stack direction={"row"} spacing={1} justifyContent={"flex-end"}>
          <Button
            label="戻る"
            onClick={onClose}
            disabled={isSubmitting}
            size={SizingWrapperStyle.INHERIT}
            variant={ButtonVariantOption.Outlined}
          />
          <Button
            label="確定する"
            onClick={() => {
              void onConfirm();
            }}
            disabled={isSubmitting}
            size={SizingWrapperStyle.INHERIT}
            variant={ButtonVariantOption.Contained}
            hasLoading={true}
            loading={isSubmitting}
          />
        </Stack>
      </Stack>
    </CustomModal>
  );
};
